/* ============================================================
   sl-map.js  —  map-by studiolab
   Tab activation, lazy iframe mount, keyboard navigation.
   Scoped per [data-sl-map-section] so multiple sections coexist.
   ============================================================ */
(function () {
  'use strict';

  function ensureIframe(panel, name, src) {
    var iframe = panel.querySelector('iframe');
    var placeholder = panel.querySelector('[data-sl-placeholder]');
    if (!iframe) {
      iframe = document.createElement('iframe');
      iframe.setAttribute('loading', 'lazy');
      iframe.setAttribute('referrerpolicy', 'no-referrer-when-downgrade');
      iframe.setAttribute('allow', 'fullscreen');
      iframe.setAttribute('frameborder', '0');
      panel.appendChild(iframe);
      if (placeholder) placeholder.style.display = 'none';
    }
    if (name) iframe.setAttribute('title', 'Mapa: ' + name);
    if (src && iframe.getAttribute('src') !== src) {
      iframe.setAttribute('src', src);
    }
  }

  function getSection(el) {
    return el.closest ? el.closest('[data-sl-map-section]') : null;
  }

  function getTabs(section) {
    var tablist = section.querySelector('[data-sl-map-tablist]');
    if (!tablist) return [];
    return Array.prototype.slice.call(tablist.querySelectorAll('[data-sl-tab]'));
  }

  function activate(btn) {
    var section = getSection(btn);
    if (!section) return;
    var panel = section.querySelector('[data-sl-map-panel]');
    if (!panel) return;

    var tabs = getTabs(section);
    tabs.forEach(function (t) {
      var isActive = t === btn;
      t.setAttribute('aria-selected', isActive ? 'true' : 'false');
      t.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    var src = btn.getAttribute('data-sl-embed') || section.getAttribute('data-sl-fallback-embed') || '';
    var name = btn.getAttribute('data-sl-name') || '';

    panel.setAttribute('aria-labelledby', btn.id || '');
    if (src) ensureIframe(panel, name, src);

    try { btn.focus({ preventScroll: true }); } catch (e) { btn.focus(); }
  }

  function mountInitial(section) {
    var panel = section.querySelector('[data-sl-map-panel]');
    if (!panel) return;
    var tabs = getTabs(section);
    var active = tabs.filter(function (t) { return t.getAttribute('aria-selected') === 'true'; })[0] || tabs[0];

    var src;
    var name;
    if (active) {
      src = active.getAttribute('data-sl-embed');
      name = active.getAttribute('data-sl-name') || '';
      active.setAttribute('aria-selected', 'true');
      active.setAttribute('tabindex', '0');
      panel.setAttribute('aria-labelledby', active.id || '');
    }
    if (!src) {
      src = section.getAttribute('data-sl-fallback-embed') || '';
      name = '';
    }
    if (src) ensureIframe(panel, name, src);
  }

  function bindKeyboard(section) {
    var tablist = section.querySelector('[data-sl-map-tablist]');
    if (!tablist) return;
    tablist.addEventListener('keydown', function (e) {
      var tabs = getTabs(section);
      if (!tabs.length) return;
      var i = tabs.indexOf(document.activeElement);
      if (i < 0) return;
      var next = -1;
      switch (e.key) {
        case 'ArrowDown':
        case 'ArrowRight':
          next = (i + 1) % tabs.length;
          break;
        case 'ArrowUp':
        case 'ArrowLeft':
          next = (i - 1 + tabs.length) % tabs.length;
          break;
        case 'Home':
          next = 0;
          break;
        case 'End':
          next = tabs.length - 1;
          break;
      }
      if (next >= 0) {
        e.preventDefault();
        activate(tabs[next]);
      }
    });
  }

  function initSection(section) {
    if (!section || section.__slMapInit) return;
    section.__slMapInit = true;

    var tabs = getTabs(section);
    if (!tabs.length) return;

    bindKeyboard(section);

    var hasIO = typeof window.IntersectionObserver === 'function';
    if (hasIO) {
      var io = new IntersectionObserver(function (entries) {
        for (var k = 0; k < entries.length; k++) {
          if (entries[k].isIntersecting) {
            mountInitial(section);
            io.disconnect();
            break;
          }
        }
      }, { rootMargin: '200px 0px', threshold: 0.05 });
      io.observe(section);
    } else {
      mountInitial(section);
    }
  }

  function initAll(root) {
    var scope = root || document;
    var sections = scope.querySelectorAll('[data-sl-map-section]');
    Array.prototype.forEach.call(sections, initSection);
  }

  // Public API used by inline onclick on each tab
  window.slMap = window.slMap || {};
  window.slMap.activate = activate;
  window.slMap.initSection = initSection;
  window.slMap.initAll = initAll;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Theme Editor live updates
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
  document.addEventListener('shopify:block:select', function (e) {
    var btn = e.target && e.target.querySelector ? e.target.querySelector('[data-sl-tab]') : null;
    if (btn) activate(btn);
  });
})();
